import React from "react";
import { Typography } from "@material-ui/core";
import { LinkedIn, YouTube, Facebook, Twitter } from "@material-ui/icons";
import { useStyles } from "./styles";

function Footer({ resize }) {
  const classes = useStyles();

  return (
    <footer
      className={classes.root}
      style={{
        width: resize ? "calc(100% - 350px)" : "100%",
        left: resize ? 350 : 0,
      }}
    >
      <Typography className={classes.text}>
        &copy; { new Date().getFullYear()} e-Auditoria. Todos os direitos reservados.
      </Typography>

      <div className={classes.social}>
        <a
          className={classes.socialLink}
          href="https://facebook.com/eauditoriasaas"
          rel="noopener noreferrer"
          target="_blank"
        >
          <Facebook />
        </a>
        <a
          className={classes.socialLink}
          href="https://twitter.com/e_auditoria"
          rel="noopener noreferrer"
          target="_blank"
        >
          <Twitter />
        </a>
        <a
          className={classes.socialLink}
          href="https://linkedin.com/company/eauditoria"
          rel="noopener noreferrer"
          target="_blank"
        >
          <LinkedIn />
        </a>
        <a
          className={classes.socialLink}
          href="https://youtube.com/user/eauditoria"
          rel="noopener noreferrer"
          target="_blank"
        >
          <YouTube />
        </a>
        <a
          className={classes.socialLink}
          href="http://www.e-auditoria.com.br"
          rel="noopener noreferrer"
          target="_blank"
        >
          <img
            className={classes.socialIconImg}
            src="https://images.e-auditoria.com.br/global/logos/png/e-auditoria-white.png"
            alt="e-Auditoria"
          />
        </a>
      </div>
    </footer>
  );
}

export default Footer;
